import Vue from 'vue';
// @ts-ignore
import MQ from 'vue-match-media/dist/index';

Vue.use(MQ);



// WEBPACK FOOTER //
// ./src/plugins/Mq.ts